import Select from "react-select";

function DropdownControl(props) {

  const handleChange = (e) => {
    props.handleDropdownChange(e);
  }

  const fontSize = "14px";

  const dropdownStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: "white",
      fontSize: fontSize,
      cursor: isDisabled ? "not-allowed" : "pointer",
      margin: "2px 0 2px 0"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: "#fff",
        color: "#000",
        cursor: isDisabled ? "not-allowed" : "pointer",
        fontSize: fontSize,
        padding: "3px 8px",
      }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <Select
      menuPortalTarget={document.body}
      menuPosition="absolute"
      defaultValue={props.defaultValue}
      value={props.options.find(obj => obj.value === props.selectedValue)}
      isMulti={props.isMulti}
      styles={dropdownStyles}
      options={props.options}
      onChange={handleChange}
      closeMenuOnSelect={
        typeof props.closeMenuOnSelect !== "undefined" ? props.closeMenuOnSelect : true
      }
      closeMenuOnScroll={true}
    />
  );
}

export default DropdownControl;
